export const trimString = (string: string, maxLength: number) =>
	string && string.trim().length > maxLength ? `${string.trim().slice(0, maxLength)}...` : string
